export default "__VITE_ASSET__BRv66GWs__"